// extracted by mini-css-extract-plugin
export default {"App":"CategoriesFaq_App__RsO+W","card":"CategoriesFaq_card__UY939"};